import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Button,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import PaymentDue from "./payments/PaymentDue";
import LockIcon from "@mui/icons-material/Lock";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import axios from "axios";
import { getValidToken } from "../utils/authUtils";
import { handleLogout } from "../utils/utils";
import { useQueryClient } from "@tanstack/react-query";

const AccountLocked: React.FC = () => {
  const [paymentDueData, setPaymentDueData] = useState<any>(null);
  const queryClient = useQueryClient();
  const fetchPaymentDue = async () => {
    const token = await getValidToken();
    const url = `${process.env.REACT_APP_API_HOST}payments/active-orders`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const paymentData = {
      isSuccess: response.data.isSuccess,
      data: response.data.data,
    };
    setPaymentDueData(paymentData);
  };

  useEffect(() => {
    fetchPaymentDue();
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 1 }}>
      <Paper
        elevation={3}
        sx={{
          p: 2,
          textAlign: "center",
          border: "2px solid #f44336",
          borderRadius: 2,
        }}
      >
        <Box>
          <LockIcon sx={{ fontSize: 80, color: "#f44336" }} />
          <Typography variant="h4" fontWeight="bold" color="error" gutterBottom>
            Account Locked
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
            Your account has been temporarily locked due to overdue payments
          </Typography>
        </Box>

        <Alert severity="warning" sx={{ textAlign: "left", mb: 1 }}>
          <Typography variant="body1" fontWeight="medium" gutterBottom>
            Access Restricted
          </Typography>
          <Typography variant="body2">
            Your account access has been restricted due to overdue payments.
            Please complete your payment to restore full access to Gaadi Kharcha
            services, or logout if you wish to exit the application.
          </Typography>
        </Alert>
        <PaymentDue paymentDue={paymentDueData} />

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Button
            variant="outlined"
            size="large"
            color="error"
            onClick={() => handleLogout(queryClient)}
            startIcon={<ExitToAppIcon />}
            sx={{
              py: 1,
              px: 2,
              fontSize: "1.1rem",
              fontWeight: "medium",
              minWidth: 200,
            }}
          >
            Logout
          </Button>
        </Box>

        <Box sx={{ mt: 1, p: 1, bgcolor: "#f5f5f5", borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Need help?</strong> Contact our support team if you believe
            this is an error or if you need assistance with your payment.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default AccountLocked;
